<template>
  <div class="el-pagination">
    <ul class="el-pager">
      <li :class="{disabled: selected === 1}"
          @click="handlePrevPage()">
        <i class="fa fa-angle-left"></i>
      </li>
      <li v-for="pageNumber of scale"
          :key="pageNumber"
          :class="{active: pageNumber === selected}"
          @click.prevent="handlePageSelected(pageNumber)"
          @mouseover="mouseOver(pageNumber)"
          @mouseleave="mouseLeave()">
        <span v-if="pageNumber === -1">
          <i v-show="leftMoreActive" class="zmdi zmdi-fast-rewind"></i>
          <i v-show="!leftMoreActive" class="zmdi zmdi-more"></i>
        </span>
        <span v-else-if="pageNumber === -2">
          <i v-show="rightMoreActive" class="zmdi zmdi-fast-forward"></i>
          <i v-show="!rightMoreActive" class="zmdi zmdi-more"></i>
        </span>
        <span v-else>{{ pageNumber }}</span>
      </li>
      <li :class="{disabled: selected === pageCount || pageCount === 0}"
          @click="handleNextPage()">
        <i class="fa fa-angle-right"></i>
      </li>
    </ul>
    <span class="el-pagination__total">{{rangeStartPage}}-{{rangeEndPage}} {{ text('of') }} {{ total }}</span>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
    },
    limit: {
      type: Number,
    },
    offset: {
      type: Number,
    },
    prevPage: {
      type: Function,
      default: () => {
      },
    },
    nextPage: {
      type: Function,
      default: () => {
      },
    },
    forcePage: {
      type: Number,
    },
  },
  data() {
    return {
      scale: [],
      innerScale: [],
      selected: 1,
      leftMoreActive: false,
      rightMoreActive: false,
      fastForwardCount: 5,
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    rangeStartPage() {
      if (this.total === 0) {
        return 0;
      }
      const start = (this.selected * this.limit) - this.limit + 1;
      if (start < 0) {
        return 0;
      }
      return start;
    },
    rangeEndPage() {
      const end = this.selected * this.limit;
      if (end > this.total) {
        return this.total;
      }
      return end;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  created() {
    this.calcSelected();
    this.calcScale();
  },
  methods: {
    calcSelected() {
      if (this.offset > 0 && this.total > 0) {
        const page = this.offset / this.limit;
        if (this.offset % this.limit === 0) {
          this.selected = Math.floor(page) + 1;
        } else {
          this.selected = Math.floor(page);
        }
      }
    },
    handlePageSelected(selected) {
      if (this.selected === selected) return;

      switch (selected) {
        case -1:
          if ((this.selected - this.fastForwardCount) <= 1) {
            this.selected = 1;
          } else {
            this.selected = this.selected - this.fastForwardCount;
          }
          break;
        case -2:
          if ((this.selected + this.fastForwardCount) >= this.pageCount) {
            this.selected = this.pageCount;
          } else {
            this.selected = this.selected + this.fastForwardCount;
          }
          break;

        default:
          this.selected = selected;
          break;
      }
      this.calcScale();
      this.$emit('onPageChange', this.selected);
    },
    handlePrevPage() {
      if (this.selected <= 1) return;
      this.handlePageSelected(this.selected - 1);
    },
    handleNextPage() {
      if (this.selected >= this.pageCount) return;
      this.handlePageSelected(this.selected + 1);
    },
    calcScale() {
      this.innerScale = [];
      if (this.pageCount <= 7) {
        for (let i = 1; i <= this.pageCount; i++) {
          this.innerScale.push(i);
        }
        this.setScale(this.innerScale);
        return;
      }
      if (this.selected <= 3) {
        this.innerScale = [1, 2, 3, 4, 5, -2, this.pageCount];
        this.setScale(this.innerScale);
        return;
      }
      if (this.selected >= (this.pageCount - 2)) {
        this.innerScale = [1, -1, this.pageCount - 4, this.pageCount - 3,
          this.pageCount - 2, this.pageCount - 1, this.pageCount];
        this.setScale(this.innerScale);
        return;
      }
      this.innerScale = [1, -1, this.selected - 1, this.selected,
        this.selected + 1, -2, this.pageCount];
      this.setScale(this.innerScale);
    },
    setScale(newScale) {
      this.scale = newScale;
    },
    mouseOver(page) {
      if (page === -1) {
        this.leftMoreActive = true;
      }
      if (page === -2) {
        this.rightMoreActive = true;
      }
    },
    mouseLeave() {
      this.leftMoreActive = false;
      this.rightMoreActive = false;
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return '';
    },
  },
  watch: {
    total() {
      this.calcScale();
    },
    offset() {
      this.calcSelected();
      this.calcScale();
    },
    forcePage(page) {
      if (this.selected !== page) {
        this.handlePageSelected(page);
      }
    },
  },
};
</script>
